import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import AssetSystem from 'src/systems/AssetSystem';

import Asset from '../../models/asset';
import { downloadAssetsPresenterFactoryFor } from './utils';

type DownloadAssetParams = {
	asset: Asset;
	withRoundNumber?: boolean;
	allRounds?: boolean;
	lowRes?: boolean;
	withMarkups?: boolean;
	unpreviewable?: boolean;
}

type UseReduxDownloadAssetParams = {
	shareRef?: string;
	onDownloadFinish?: () => void;
}

const useReduxDownloadAsset = ( { shareRef, onDownloadFinish }: UseReduxDownloadAssetParams ) => {
	const dispatch = useDispatch();
	const snackbarSystem = useSnackbarSystem();
	const assetSystem = new AssetSystem( dispatch );

	return useCallback( ( {
		asset, withRoundNumber, allRounds, lowRes, withMarkups, unpreviewable
	}: DownloadAssetParams ) => {
		const presenter = downloadAssetsPresenterFactoryFor( shareRef ).forDownloadAsset( {
			asset,
			assetSystem,
			snackbarSystem,
			withRoundNumber,
			allRounds,
			lowRes,
			withMarkups,
			onFinish: onDownloadFinish,
			unpreviewable
		} )

		presenter.trigger();
	}, [ onDownloadFinish, assetSystem, snackbarSystem, shareRef ] );
}

export default useReduxDownloadAsset;
